import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';

var Weekday = /*#__PURE__*/function () {
  var Weekday = /*#__PURE__*/function (_Component) {
    _inheritsLoose(Weekday, _Component);

    function Weekday() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = Weekday.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    };

    _proto.render = function render() {
      var _this$props = this.props,
          weekday = _this$props.weekday,
          className = _this$props.className,
          weekdaysLong = _this$props.weekdaysLong,
          weekdaysShort = _this$props.weekdaysShort,
          localeUtils = _this$props.localeUtils,
          locale = _this$props.locale;
      var title;

      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }

      var content;

      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return /*#__PURE__*/React.createElement("div", {
        className: className,
        role: "columnheader"
      }, /*#__PURE__*/React.createElement("abbr", {
        title: title
      }, content));
    };

    return Weekday;
  }(Component);

  return Weekday;
}();

export default Weekday;